const colors = {
  LAYOUT_COLOR: "#5c4881e5",
  HEADER_CARD_COLOR: "#750f4bff",
  VENCIMENTO_CARD_COLOR: "#6b257928",
  BUTTON_COLOR: "#6b2579ff",
};

export default colors;
